// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/expense.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { DateSchedule } from "../../optimizer/v1/date_schedule";
import { Date } from "./date";
/**
 * @generated from protobuf message core.v1.MortgageExpenseDetails
 */
export interface MortgageExpenseDetails {
    /**
     * @generated from protobuf field: core.v1.MortgageExpenseDetails.Type type = 1;
     */
    type: MortgageExpenseDetails_Type; // required
    /**
     * @generated from protobuf field: string mortgage_uuid = 2;
     */
    mortgageUuid: string;
}
/**
 * @generated from protobuf enum core.v1.MortgageExpenseDetails.Type
 */
export enum MortgageExpenseDetails_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TYPE_PROPERTY_TAX = 1;
     */
    PROPERTY_TAX = 1
}
/**
 * @generated from protobuf message core.v1.HouseholdExpenseDetails
 */
export interface HouseholdExpenseDetails {
    /**
     * @generated from protobuf field: core.v1.HouseholdExpenseDetails.Type type = 1;
     */
    type: HouseholdExpenseDetails_Type; // required
}
/**
 * @generated from protobuf enum core.v1.HouseholdExpenseDetails.Type
 */
export enum HouseholdExpenseDetails_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TYPE_ESSENTIAL_EXPENSES = 1;
     */
    ESSENTIAL_EXPENSES = 1,
    /**
     * @generated from protobuf enum value: TYPE_NON_ESSENTIAL_EXPENSES = 2;
     */
    NON_ESSENTIAL_EXPENSES = 2,
    /**
     * @generated from protobuf enum value: TYPE_RENT = 3;
     */
    RENT = 3,
    /**
     * @generated from protobuf enum value: TYPE_UNEXPECTED_EXPENSE = 4;
     */
    UNEXPECTED_EXPENSE = 4,
    /**
     * @generated from protobuf enum value: TYPE_CUSTOM_EXPENSES = 5;
     */
    CUSTOM_EXPENSES = 5
}
/**
 * @generated from protobuf message core.v1.Expense
 */
export interface Expense {
    /**
     * @generated from protobuf oneof: details
     */
    details: {
        oneofKind: "mortgageExpenseDetails";
        /**
         * @generated from protobuf field: core.v1.MortgageExpenseDetails mortgage_expense_details = 1;
         */
        mortgageExpenseDetails: MortgageExpenseDetails;
    } | {
        oneofKind: "householdExpenseDetails";
        /**
         * @generated from protobuf field: core.v1.HouseholdExpenseDetails household_expense_details = 2;
         */
        householdExpenseDetails: HouseholdExpenseDetails;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string uuid = 3;
     */
    uuid: string; // identifier, BE default
    /**
     * @generated from protobuf field: string name = 4;
     */
    name: string; // display label only; never used to classify (use the details type)
    /**
     * @generated from protobuf field: double amount_due_per_period = 5;
     */
    amountDuePerPeriod: number; // required
    /**
     * @generated from protobuf field: core.v1.Date last_known_due_date = 7;
     */
    lastKnownDueDate?: Date; // optional; the last known occurrence, rolled forward by the engine
    /**
     * @generated from protobuf field: optional bool is_recurring = 8;
     */
    isRecurring?: boolean; // optional
    /**
     * @generated from protobuf field: core.v1.Date end_date = 9;
     */
    endDate?: Date; // optional
    /**
     * @generated from protobuf field: optimizer.v1.DateSchedule date_schedule = 10;
     */
    dateSchedule?: DateSchedule; // optional, optimizer default; migrating from schedule
}
// @generated message type with reflection information, may provide speed optimized methods
class MortgageExpenseDetails$Type extends MessageType<MortgageExpenseDetails> {
    constructor() {
        super("core.v1.MortgageExpenseDetails", [
            { no: 1, name: "type", kind: "enum", T: () => ["core.v1.MortgageExpenseDetails.Type", MortgageExpenseDetails_Type, "TYPE_"] },
            { no: 2, name: "mortgage_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.MortgageExpenseDetails
 */
export const MortgageExpenseDetails = new MortgageExpenseDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HouseholdExpenseDetails$Type extends MessageType<HouseholdExpenseDetails> {
    constructor() {
        super("core.v1.HouseholdExpenseDetails", [
            { no: 1, name: "type", kind: "enum", T: () => ["core.v1.HouseholdExpenseDetails.Type", HouseholdExpenseDetails_Type, "TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.HouseholdExpenseDetails
 */
export const HouseholdExpenseDetails = new HouseholdExpenseDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Expense$Type extends MessageType<Expense> {
    constructor() {
        super("core.v1.Expense", [
            { no: 1, name: "mortgage_expense_details", kind: "message", oneof: "details", T: () => MortgageExpenseDetails },
            { no: 2, name: "household_expense_details", kind: "message", oneof: "details", T: () => HouseholdExpenseDetails },
            { no: 3, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "amount_due_per_period", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "last_known_due_date", kind: "message", T: () => Date },
            { no: 8, name: "is_recurring", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "end_date", kind: "message", T: () => Date },
            { no: 10, name: "date_schedule", kind: "message", T: () => DateSchedule }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Expense
 */
export const Expense = new Expense$Type();
